import { inject, Injectable, InjectionToken } from '@angular/core';
import { GoogleTagManagerConfig } from './google-tag-manager-config';

export const GoogleTagManagerConfigService =
  new InjectionToken<GoogleTagManagerConfig>('google-tag-manager-config');

// adapted from https://github.com/auth0/auth0-angular#dynamic-configuration
@Injectable({ providedIn: 'root' })
export class GoogleTagManagerConfiguration {
  private _googleTagManagerConfig: GoogleTagManagerConfig = {
    id: '',
    gtm_auth: '',
    gtm_preview: ''
  };

  private readonly googleTagManagerConfig = inject(
    GoogleTagManagerConfigService,
    { optional: true }
  );

  constructor() {
    if (this.googleTagManagerConfig) {
      this.set(this.googleTagManagerConfig);
    }
  }

  public set(googleTagManagerConfig: GoogleTagManagerConfig): void {
    this._googleTagManagerConfig = googleTagManagerConfig;
  }

  public get(): GoogleTagManagerConfig {
    return this._googleTagManagerConfig;
  }
}
